import DataReferenceSourceType from './DataReferenceSourceType.js';
const KEY_SEPARATOR = ':';
/**
 * @memberof data-references
 * @property {DataReferenceSourceType} type
 * @property {?number} sourceId
 * @property {string|number} column
 */
class DataReference {
    /**
     * @param {object} props
     * @param {DataReferenceSourceType} props.type
     * @param {?number} props.sourceId
     * @param {string|number} props.column
     */
    constructor(props) {
        /**
         * @property {DataReferenceSourceType} type
         * @property {?number} sourceId
         * @property {string|number} column
         */
        this.type = props.type;
        this.sourceId = props.sourceId;
        this.column = props.column;
    }
    /**
     * @property {string}
     */
    get key() {
        return [this.type, (this.sourceId || ''), this.column].join(KEY_SEPARATOR);
    }
    /**
     * @param {data-references.DataSpecifier}
     * @return {boolean}
     */
    isEqual(reference) {
        return reference.key === this.key;
    }
    /**
     * @return {object}
     */
    toJSON() {
        return {
            type: this.type,
            sourceId: this.sourceId,
            column: this.column,
        };
    }
    /**
     * @param {string} key
     * @return {DataReference}
     */
    static fromKey(key) {
        const [type, sourceId, column] = key.split(KEY_SEPARATOR);
        const parseSourceId = type === DataReferenceSourceType.SYSTEM ? identity : parseNumber;
        const parseColumn = type === DataReferenceSourceType.SYSTEM ? parseNumber : identity;
        return new DataReference({ type: DataReferenceSourceType[type], sourceId: parseSourceId(sourceId), column: parseColumn(column) });
    }
}
DataReference.SourceType = DataReferenceSourceType;
function identity(value) {
    return value;
}
function parseNumber(value) {
    return parseInt(value, 10);
}
export default DataReference;
